import React, { useEffect, useState } from 'react';
import './attendance.min.css'
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { UserAuth } from '../auth/Auth';
import { isURL } from '../../environment/Helper';
import { PrivateAxios, PrivateAxiosFile, url } from '../../environment/AxiosInstance';
import { ErrorMessage, SuccessMessage } from './../../environment/ToastMessage';
import moment from 'moment';
import * as XLSX from "xlsx";
import { SlideshowLightbox } from 'lightbox.js-react';


import Webcam from "react-webcam";
import { Modal, Button } from 'react-bootstrap';

function Attendance() {


  // ==============================Set leave type==============================
  const [showLeaveType, setShowLeaveType] = useState(false);
  const [showCheckInModal, setShowCheckInModal] = useState(false);
  const [checkInStatus, setCheckInStatus] = useState(false);
  const [imgSrc, setImgSrc] = useState(null);
  const [location, setLocation] = useState(null);
  const webcamRef = React.useRef(null);


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const { User, companyInfoGlobal, userDetails } = UserAuth();
  const [loading, setLoading] = useState(false);
  const [monthYear, setMonthYear] = useState([]);
  const [presentData, setPresentData] = useState([]);



  const [totalPresentData, setTotalPresentData] = useState(0);
  const [totalAbsentData, setTotalAbsentData] = useState(0);
  // totalPresent

  const [select, setselect] = useState(`${new Date().toLocaleString('default', { month: 'long' })}-${new Date().getFullYear()}`);
  function getLast6MonthsIncludingCurrent() {
    const result = [];
    const now = new Date();
    for (let i = 6; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthIndex = date.getMonth(); // 0-based
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();

      const lastDay = new Date(year, monthIndex + 1, 0).getDate();
      const total = Array.from({ length: lastDay }, (_, index) => index + 1);
      result.push({
        month,
        year,
        total
      });
    }
    setMonthYear(result);
  }

  const GetLeaveType = () => {
    PrivateAxios.get('attendance/get-leave-type')
      .then((res) => {
        if (res.data.success) {
          setTagsOption(JSON.parse(res.data.data.level_type));
        } else {
          ErrorMessage("Failed to load leave types")
        }
      }).catch((err) => {
        ErrorMessage("Something went wrong !. leave types is missing!")
      })
  }
  const GetPresentData = (data) => {
    const [monthName, yearStr] = data.split("-");
    const monthIndex = new Date(`${monthName} 1, ${yearStr}`).getMonth() + 1;
    const year = parseInt(yearStr);
    PrivateAxios.post('attendance/get-present-data', { month: monthIndex, year: year })
      .then((res) => {
        if (res.data.success) {
          setPresentData(res.data.data);
          setTotalPresentData(res.data.totalPresent)
          setTotalAbsentData(User.length - Number(res.data.totalPresent))
        } else {
          ErrorMessage("Failed to load leave types")
        }
      }).catch((err) => {
        ErrorMessage("Something went wrong while loading leave types !")
      })
  }

  const checkAttendanceStatus = () => {
    PrivateAxios.get('attendance/get-attendance')
      .then((res) => {
        if (res.data.success) {
          setCheckInStatus(res.data.checkIn);
        }
      }).catch((err) => {
        console.error("Error fetching attendance status", err);
      });
  }

  useEffect(() => {
    getLast6MonthsIncludingCurrent();
    GetLeaveType();
    GetPresentData(select);
    checkAttendanceStatus();
  }, [User])

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      ErrorMessage("Geolocation is not available");
    }
  }, [webcamRef]);

  const submitAttendance = () => {
    if (!imgSrc || !location) {
      ErrorMessage("Please capture photo and allow location access");
      return;
    }

    // Convert base64 to blob
    fetch(imgSrc)
      .then(res => res.blob())
      .then(blob => {
        const formData = new FormData();
        formData.append("file", blob, "attendance.jpg");
        formData.append("location", JSON.stringify(location));

        PrivateAxiosFile.post('attendance/check-in-out', formData)
          .then((res) => {
            if (res.data.success) {
              SuccessMessage(res.data.message);
              setCheckInStatus(!checkInStatus);
              setShowCheckInModal(false);
              setImgSrc(null);
              GetPresentData(select); // Refresh data
              checkAttendanceStatus();
            } else {
              ErrorMessage(res.data.message);
            }
          }).catch((err) => {
            ErrorMessage("Attendance action failed");
          });
      });
  }

  // ==============================State for managing the tags input==============================
  const [tagsOption, setTagsOption] = useState([]);
  const handleChangeTagOption = (newTags) => {
    if (newTags.some(tag => tag.toLowerCase() === 'present'.toLowerCase()) || newTags.some(tag => tag.toLowerCase() === 'absent'.toLowerCase())) {
      // WaringMessage("Those types already added !");
      return;
    }
    setTagsOption(newTags);
    PrivateAxios.post('attendance/create-leave-type', { level_type: JSON.stringify(newTags) })
      .then((res) => {
        if (res.data.success) {
          setTagsOption(JSON.parse(res.data.data.level_type));
          SuccessMessage(res.data.message)
        } else {
          ErrorMessage("Failed to create leave types")
        }
      }).catch((err) => {
        ErrorMessage("Something went wrong while create leave types !")
      })
  };


  const SelectedAttendType = (data, userId, date) => {
    if (!data || !userId || !date) return;
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const currentTime = `${hours}:${minutes}:${seconds}`;
    // Combine date and time
    const [day, monthName, year] = date.split("-");
    const fullDate = new Date(`${monthName} ${day}, ${year} ${currentTime}`);
    const pad = (n) => String(n).padStart(2, '0');
    const formatted = `${fullDate.getFullYear()}-${pad(fullDate.getMonth() + 1)}-${pad(fullDate.getDate())}T${pad(fullDate.getHours())}:${pad(fullDate.getMinutes())}:${pad(fullDate.getSeconds())}`;

    const payload = {
      leave_type: data,
      user_id: userId,
      date: new Date(formatted)
    }
    PrivateAxios.post('attendance/select-attend-time', payload)
      .then((res) => {
        if (res.data.success) {
          SuccessMessage(res.data.message);
          GetPresentData(select);
        } else {
          ErrorMessage("Failed to create leave types")
        }
      }).catch((err) => {
        ErrorMessage("Something went wrong while create select attend type !")
      })
  }

  ////////////////////////////////////////////////////////////////////////////
  const exportToExcel = () => {
    if (!User || User.length === 0) {
      alert("No users found to export.");
      return;
    }

    const [monthName, yearStr] = select.split("-");
    const year = parseInt(yearStr);
    const monthIndex = new Date(`${monthName} 1, ${yearStr}`).getMonth(); // 0-based index
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

    const exportData = [];

    // Iterate through each day of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const dateObj = new Date(year, monthIndex, day);
      const dateString = moment(dateObj).format('DD/MM/YYYY');

      // Iterate through each user
      User.forEach(user => {
        // Find attendance record for this user and this day
        const match = presentData.find(item =>
          item.user_id == user.id &&
          new Date(item.created_at).getDate() == day
        );

        let status = "Absent";
        let startTime = "-";
        let endTime = "-";
        let totalHours = "-";
        let leaveType = "-";

        if (match) {
          // Status Logic matching the render logic
          if (match.status == 1) status = "Present";
          else if (match.leave_type && match.leave_type !== "Present") status = match.leave_type;

          if (match.status == 1 || match.leave_type === "Present") {
            status = "Present";
          } else {
            status = match.leave_type || "Absent";
          }

          if (match.in_time) {
            startTime = moment(match.in_time).format('hh:mm A');
          }

          if (match.out_time) {
            endTime = moment(match.out_time).format('hh:mm A');
          }

          if (match.in_time && match.out_time) {
            const start = moment(match.in_time);
            const end = moment(match.out_time);
            const duration = moment.duration(end.diff(start));
            const hours = Math.floor(duration.asHours());
            const minutes = duration.minutes();
            totalHours = `${hours}h ${minutes}m`;
          }
        }

        // Push to export data
        exportData.push({
          "Date": dateString,
          "Employee Name": user.name,
          "Status": status,
          "Start Time": startTime,
          "End Time": endTime,
          "Total Hours": totalHours
        });
      });
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Auto-width for columns (optional but nice)
    const wscols = [
      { wch: 15 }, // Date
      { wch: 30 }, // Name
      { wch: 15 }, // Status
      { wch: 15 }, // Start
      { wch: 15 }, // End
      { wch: 15 }  // Total
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Attendance Detailed");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Create a link and trigger download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Attendance_Detailed_${select}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  const [todayStats, setTodayStats] = useState({ inTime: null, outTime: null, totalHours: null });
  useEffect(() => {
    if (presentData.length > 0 && userDetails?.id) {
      const today = new Date();
      const todayRecord = presentData.find(item =>
        item.user_id === userDetails.id &&
        new Date(item.created_at).toDateString() === today.toDateString()
      );

      if (todayRecord) {
        let inTime = todayRecord.in_time ? moment(todayRecord.in_time).format('hh:mm A') : null;
        let outTime = todayRecord.out_time ? moment(todayRecord.out_time).format('hh:mm A') : null;
        let totalHours = null;

        if (todayRecord.in_time && todayRecord.out_time) {
          const start = moment(todayRecord.in_time);
          const end = moment(todayRecord.out_time);
          const duration = moment.duration(end.diff(start));
          // Format duration as HH:mm
          const hours = Math.floor(duration.asHours());
          const minutes = duration.minutes();
          totalHours = `${hours}h ${minutes}m`;
        }

        setTodayStats({ inTime, outTime, totalHours });
      } else {
        setTodayStats({ inTime: null, outTime: null, totalHours: null });
      }
    }
  }, [presentData, userDetails]);


  return (
    <>
      <div className='p-4'>
        <div className='row'>
          <div className='col-lg-6'>
            <h5 className='fw-bold'>Attendance</h5>
            <div className='row'>
              <div className='col-md-6'>
                <div className='card bg-gradient-left-1'>
                  <div className='card-body p-4 d-flex justify-content-between align-items-center'>
                    <div>
                      <h6 className='card-title'>Total Attendance</h6>
                      <p className='card-text fs-1 line-height-1 fw-bold'>{totalPresentData}</p>
                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width={40}
                        height={40}
                        x={0}
                        y={0}
                        viewBox="0 0 1707 1707"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                        fillRule="evenodd"
                        className=""
                      >
                        <g>
                          <path fill="#f73b6c" d="M730 1156H380c-187 0-341 153-341 341v210h1205l-419-551z" opacity={1} data-original="#f73b6c" />
                          <path fill="#c83057" d="M621 1217c0-9 8-17 17-17 10 0 17 8 17 17v153c0 9-7 17-17 17-9 0-17-8-17-17zM185 1707h68v-152c0-19-15-34-34-34s-34 15-34 34z" opacity={1} data-original="#c83057" />
                          <g fill="#ff9f83">
                            <path d="M543 947h190v184c0 52-43 94-95 94s-95-42-95-94zM935 727l4-151h42c42 0 76 34 76 76s-34 76-76 76c-4 0-42-1-46-1zM354 576l5 151c-4 0-59 1-63 1-42 0-76-34-76-76s34-76 76-76z" fill="#ff9f83" opacity={1} data-original="#ff9f83" />
                          </g>
                          <path fill="#ffb192" d="M308 727c12 136 108 249 235 288 31 9 62 13 95 13s65-4 95-13c128-39 223-152 236-288 1-10 1-20 1-30V582s13-157-91-174c-40-6-52-12-87-7-42 7-116 6-205-46-185-110-265-12-281 228v114c0 10 1 20 2 30z" opacity={1} data-original="#ffb192" />
                          <path fill="#2f373b" d="M306 583s-166-302 60-436c0 0 103-251 488-97 0 0-62 42-63 66-1 23 385 31 179 466 0 0 13-140-91-157-40-6-52 5-87 10-42 7-116 6-205-46-185-110-265-46-281 194z" opacity={1} data-original="#2f373b" />
                          <circle cx={1238} cy={1277} r={430} fill="#1da2dd" opacity={1} data-original="#1da2dd" />
                          <path fill="#2f373b" fillRule="nonzero" d="M709 567c-6 8-16 9-24 4-7-6-9-16-4-24 11-14 25-26 41-34 15-8 32-12 51-12 18 0 35 4 51 12s29 20 40 34c5 8 4 18-4 24-7 5-18 4-23-4-8-10-17-18-29-24-10-5-22-8-35-8s-25 3-36 8c-11 6-21 14-28 24zM440 567c-5 8-16 9-24 4-7-6-9-16-3-24 10-14 24-26 40-34 15-8 33-12 51-12s36 4 51 12c16 8 30 20 40 34 6 8 4 18-4 24-7 5-18 4-23-4-8-10-17-18-28-24-11-5-23-8-36-8s-25 3-36 8c-11 6-21 14-28 24z" opacity={1} data-original="#2f373b" />
                          <path fill="#22292b" d="M484 610c0-9 8-17 17-17 10 0 17 8 17 17v38c0 10-7 17-17 17-9 0-17-7-17-17zM758 610c0-9 8-17 17-17 10 0 17 8 17 17v38c0 10-7 17-17 17-9 0-17-7-17-17z" opacity={1} data-original="#22292b" />
                          <path fill="#e0524b" fillRule="nonzero" d="M547 813c-5-8-4-19 4-24 7-6 18-4 23 4 8 10 17 18 29 24 10 5 22 8 35 8s25-3 36-8c11-6 21-14 28-24 6-8 16-10 24-4 7 5 9 16 3 24-10 14-24 26-40 34-15 8-32 12-51 12-18 0-35-4-51-12s-29-20-40-34z" opacity={1} data-original="#e0524b" />
                          <circle cx={1238} cy={1277} r={328} fill="#ffffff" opacity={1} data-original="#ffffff" />
                          <path fill="#f6ca56" d="M1023 1350c-16-16-16-42 0-59 16-16 43-16 59 0l64 65 247-247c16-16 43-16 59 0s16 43 0 59l-276 276c-16 16-43 16-59 0z" opacity={1} data-original="#f6ca56" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='card bg-gradient-left-2'>
                  <div className='card-body p-4 d-flex justify-content-between align-items-center'>
                    <div>
                      <h6 className='card-title'>Total Leave</h6>
                      <p className='card-text fs-1 line-height-1 fw-bold'>{totalAbsentData}</p>
                    </div>
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width={40}
                        height={40}
                        x={0}
                        y={0}
                        viewBox="0 0 512.005 512"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                        className=""
                      >
                        <g>
                          <path
                            fill="#2196f3"
                            d="M298.668 277.336c-35.285 0-64-28.715-64-64s28.715-64 64-64h42.664V64.004c0-35.285-28.715-64-64-64H48c-7.02 0-13.59 3.453-17.578 9.234-3.969 5.782-4.863 13.145-2.348 19.692l154.668 405.336c3.137 8.277 11.07 13.738 19.926 13.738h74.664c35.285 0 64-28.715 64-64V277.336zm0 0"
                            opacity={1}
                            data-original="#2196f3"
                            className=""
                          />
                          <path
                            fill="#607d8b"
                            d="M397.164 318.383C389.207 315.074 384 307.289 384 298.668v-64h-85.332c-11.777 0-21.336-9.555-21.336-21.332 0-11.777 9.559-21.332 21.336-21.332H384v-64c0-8.621 5.207-16.406 13.164-19.715a21.33 21.33 0 0 1 23.25 4.633l85.336 85.332c8.34 8.34 8.34 21.824 0 30.164l-85.336 85.336a21.335 21.335 0 0 1-23.25 4.629zm0 0"
                            opacity={1}
                            data-original="#607d8b"
                          />
                          <path
                            fill="#64b5f6"
                            d="M184.45 44.844 56.257 2.114C27.328-6.782 0 14.573 0 42.667v384c0 18.242 11.605 34.52 28.887 40.492l128.168 42.73c4.715 1.45 9.047 2.114 13.613 2.114 23.531 0 42.664-19.137 42.664-42.668v-384c0-18.238-11.605-34.516-28.883-40.492zm0 0"
                            opacity={1}
                            data-original="#64b5f6"
                            className=""
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card'>
          <div className='card-header d-flex flex-wrap justify-content-between align-items-center gap-2'>
            <div className='d-flex align-items-center gap-2 flex-wrap'>
              <div className='min-width-200'>
                <select className='form-select form-select-sm' onChange={(e) => { setselect(e.target.value); GetPresentData(e.target.value) }}>
                  {
                    monthYear.length > 0 ? monthYear.map((data) => (
                      <option value={`${data.month}-${data.year}`} selected={`${data.month}-${data.year}` == select}>{`${data.month} -${data.year}`}</option>
                    )) : ""
                  }
                </select>
              </div>
            </div>
          </div>
          <div className='d-flex flex-wrap gap-2 justify-content-end ms-auto position-relative align-items-center'>
            {todayStats.inTime && (
              <span className="badge bg-success fs-6">
                <i className="fas fa-sign-in-alt me-1"></i> In: {todayStats.inTime}
              </span>
            )}
            {todayStats.outTime && (
              <span className="badge bg-danger fs-6">
                <i className="fas fa-sign-out-alt me-1"></i> Out: {todayStats.outTime}
              </span>
            )}
            {todayStats.totalHours && (
              <span className="badge bg-primary fs-6">
                <i className="fas fa-clock me-1"></i> Total: {todayStats.totalHours}
              </span>
            )}
            <button className="btn btn-outline-success btn-sm" onClick={exportToExcel}>
              <i className="fas fa-file-excel"></i> Export to Excel
            </button>
            <button
              type='button'
              className='btn btn-primary btn-sm'
              onClick={() => setShowLeaveType(true)}
              id="open_leave_type"
            >Set Leave Type</button>
            {showLeaveType && (
              <div className='leave-type-wrap'>
                <div className='d-flex align-items-center gap-2 mb-2'>
                  <label className='form-label'>Enter leave (Press Enter to add more)</label>
                  <button
                    className='icon-btn close_leave_type'
                    type='button'
                    onClick={() => setShowLeaveType(false)}
                    id="close_leave_type"
                  >
                    <i className="fas fa-times-circle"></i>
                  </button>
                </div>

                <TagsInput
                  value={tagsOption}
                  onChange={handleChangeTagOption}
                  inputProps={{
                    placeholder: 'Leave type',
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className='card-body'>
          <div className='table-responsive'>
            <table id="attendanceTable" className='table table-sm table-bordered v-align-middle mb-0'>
              <thead>
                <tr>
                  <th rowSpan={2}>Employee Name</th>
                  <th className='text-center' colSpan={monthYear.find(data => `${data.month}-${data.year}` == select)?.total?.length}>{select.split('-')[0]}</th>
                </tr>
                <tr>
                  {monthYear.find(data => `${data.month}-${data.year}` == select)?.total.map(item => (
                    <th className='text-center' key={item} style={{ minWidth: '50px' }}>{item}</th>
                  ))
                  }
                </tr>
              </thead>
              <tbody>
                {User.length > 0 ? User.map((emp, idx) => (
                  <tr key={idx}>
                    <td>
                      {/* <div className="profile-wrap p-0">
                          <div className="exp-avtar bg-success">
                            <img
                              className="prof-img"
                              src={emp.img}
                              alt="user"
                            />
                          </div>
                          <div className="ps-2 profile-name-wrap text-truncate">
                            <h5 className="profile-name text-nowrap text-truncate">{emp.name}</h5>
                          </div>
                        </div> */}
                      < div className="profile-wrap p-0" >
                        <div className="exp-avtar bg-success">
                          {emp.user_photo != null ?
                            < img className="prof-img" src={isURL(emp.user_photo) ? emp.user_photo : url + emp.user_photo} alt="user" /> :
                            <span>{emp.name != '' ? emp.name.split(' ').length > 1 ? emp.name.split(' ')[0].split('')[0] + emp.name.split(' ')[1].split('')[0] : emp.name.split('')[0] + emp.name.split('')[1] : ""}</span>
                          }
                        </div>
                        <div className="ps-2 profile-name-wrap text-truncate">
                          <h5 className="profile-name text-nowrap text-truncate">{emp.name}</h5>
                        </div>
                      </div>
                    </td>
                    {/* &&itemDate.created_at== */}

                    {monthYear.find(data => `${data.month}-${data.year}` == select)?.total?.map((dayIdx) => {
                      const match = presentData.find(item =>
                        item.user_id == emp.id &&
                        new Date(item.created_at).getDate() == dayIdx
                      );

                      const status = new Date() >= new Date(`${select} ${dayIdx}`) && new Date(`${select} ${dayIdx}`) >= new Date(companyInfoGlobal.created_at) ? match ? (match.status == 1 ? "P" : "A") : "Ab" : "" || "";
                      let cellClass = "";
                      if (status === "P") cellClass = "table-attandance-success text-center text-white fw-bold cursor-pointer";
                      if (status === "A" || status === "Ab") cellClass = "table-attandance-danger text-center text-white fw-bold cursor-pointer";
                      // {console.log(match,"match")
                      //  }
                      return (
                        <td key={dayIdx} className={cellClass}>
                          <OverlayTrigger
                            trigger="click"
                            rootClose
                            placement="auto"
                            overlay={
                              <Popover id="my-kpi-help" className="unique-outer-wrap">
                                <div className="unique-outer-wrap p-3">
                                  {
                                    console.log(match, "match")
                                  }
                                  {
                                    status == "P" ?
                                      <>
                                        <div className='d-flex justify-content-between gap-2 mb-1'>
                                          <div>
                                            <div className='fw-bold'><i className="fas fa-sign-in-alt me-2 text-success"></i>{match.in_time ? moment(match.in_time).format('hh:mm A') : ""}</div>
                                            <div style={{ width: '50px', height: '50px' }} className='rounded'>
                                              <SlideshowLightbox className="image-expand w-100 h-100">
                                                <img alt='employee' src={`${match?.file}`} className='img-fit rounded' />
                                              </SlideshowLightbox>
                                            </div>
                                          </div>
                                          <div className='ms-auto'>
                                            <div className='fw-bold'><i className="fas fa-sign-out-alt me-2 text-danger"></i>{match.out_time ? moment(match.out_time).format('hh:mm A') : ""}</div>
                                            <div style={{ width: '50px', height: '50px' }} className='rounded'>
                                              <SlideshowLightbox className="image-expand w-100 h-100">
                                                <img alt='employee' src={`${match?.out_file}`} className='img-fit rounded' />
                                              </SlideshowLightbox>
                                            </div>
                                          </div>
                                        </div>
                                      </> : ""
                                  }
                                  <div className='fw-bold mt-1'>
                                    <select className='form-select form-select-sm fw-bold' onChange={(e) => SelectedAttendType(e.target.value, emp.id, `${dayIdx}-${select}`)} >
                                      <option value="Absent" selected={status == "A"}>Absent</option>
                                      <option value="Present" selected={status == "P"}>Present</option>

                                      {
                                        tagsOption.length > 0 ? tagsOption.map((item, index) => (
                                          <option value={item} selected={match?.leave_type == item}>{item}</option>
                                        )) : ""
                                      }
                                    </select>
                                  </div>
                                  <div className='fw-bold mt-1'>
                                    <div className='d-flex gap-1 mb-2 align-items-start'>
                                      <i className="fas fa-map-marker-alt me-2 text-primary mt-1"></i>
                                      <div className='d-flex gap-1'>Latitude:<span style={{ wordBreak: 'break-all' }}>{match?.location ? JSON.parse(match?.location)?.latitude : ''}</span></div>
                                    </div>
                                    <div className='d-flex gap-1 mb-0 align-items-start'>
                                      <i className="fas fa-map-marker-alt me-2 text-primary mt-1"></i>
                                      <div className='d-flex gap-1'>Longitude:<span style={{ wordBreak: 'break-all' }}>{match?.location ? JSON.parse(match?.location)?.longitude : ''}</span></div>
                                    </div>
                                  </div>
                                </div>
                              </Popover>
                            }
                          >
                            <div>{status && <span className={cellClass}>{status == 'Ab' ? 'A' : ['Present', 'Absent', ...tagsOption].find(item => item == match?.leave_type)}</span>}</div>
                          </OverlayTrigger>
                        </td>
                      );
                    })}
                  </tr>
                )) : ""}
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </>
  )
}

export default Attendance

